export default "__VITE_ASSET__DPCbPoyg__"